const MAX_KWH_INPUT = 500000;

const DOB_MAX_AGE_YEARS = 110;
const DOB_MIN_AGE_YEARS = 18;

enum ValidationErrorMessages {
  FIELD_REQUIRED = 'This field is required',
  INVALID_DATE = 'Invalid date',
  DOB_AGE_MIN = 'You must be 18 years or older',
  DOB_AGE_MAX = 'Please verify the date entered is correct',
  INVALID_AMOUNT = 'Please provide valid amount',
  INVALID_SORT_CODE = 'Invalid sort code',
  INVALID_ACCOUNT_NUMBER = 'Invalid account number',
  EMAIL_EXISTS = 'Email already in use',
  INVALID_EMAIL = 'Invalid email address',
  INVALID_PHONE = 'Invalid phone number',
  INVALID_PAST_DATE = "Please provide today's or a future date",
  POSTCODE_REQUIRED = 'Postcode is required',
  INVALID_POSTCODE = 'Invalid postcode',
  NO_ADDRESS = 'No address selected',
  KWH_MAX = 'Ensure this value is less than or equal to 500000',
  CONFIRM_POLICY_DOCUMENTS = 'Please tick to confirm each of the above statements',
  DECIMAL_NOT_ALLOWED = 'Decimal values are not allowed, please enter a whole number',
  PASSWORD_MIN_LENGTH = 'Password must be at least 8 characters in length',
  PASSWORD_WRONG_FORMAT = 'At least 1 upper case letter, 1 lower case letter and 1 number',
  INVALID_CUSTOMER_ACCOUNT_NUMBER = 'Please enter a valid Customer account number',
  INVALID_APPOINTMENT_CODE = 'This is an invalid appointment code. Please check with your UW Partner and try again.',
  ACCEPT_TERMS_TO_CONTINUE = 'You must accept the terms and conditions to continue',
  ECONOMY_7_PREPAYMENT_CONFLICT = 'Economy 7 is not available with a prepayment meter. Please check your electricity meter type.',
}

export {
  ValidationErrorMessages,
  MAX_KWH_INPUT,
  DOB_MAX_AGE_YEARS,
  DOB_MIN_AGE_YEARS,
};
